module.exports = require("react");


/*****************
 ** WEBPACK FOOTER
 ** external "react"
 ** module id = 3
 ** module chunks = 0
 **/